import React, { useState } from "react";
import InputColor from "../../../views/dashboard/settings/branding/InputColor";
import submit from "submit-form";
import Modal from "../../modal-new";

export const EditIndividualPhaseModal = ({
  athleteId,
  phase,
  organizationCoachId,
}) => {
  const [modeState, setModeState] = useState("read");

  const [phaseState, setPhaseState] = useState({
    phaseName: phase.phaseName,
    phaseColor: phase.phaseColor,
  });

  const { phaseName: statePhaseName, phaseColor: statePhaseColor } = phaseState;

  const handleRemove = (e) => {
    e.preventDefault();

    let body = { athleteId, phaseName: phase.phaseName };
    if (organizationCoachId) {
      body = { ...body, organizationCoachId };
    }
    submit("/actions/annual-planner/remove-athlete-phase", {
      method: "POST",
      body,
    });
  };

  const handleChange = (input, payload) => {
    setPhaseState(Object.assign({}, phaseState, { [input]: payload }));
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    if (!statePhaseName || !statePhaseColor) return;
    if (
      statePhaseName !== phase.phaseName ||
      statePhaseColor !== phase.phaseColor
    ) {
      setModeState("read");
      let body = {
        athleteId,
        phaseName: statePhaseName,
        phaseColor: statePhaseColor,
        prevName: phase.phaseName,
      };

      if (organizationCoachId) {
        body = { ...body, organizationCoachId };
      }
      submit("/actions/annual-planner/update-athlete-phase", {
        method: "POST",
        body,
      });
    }
    return setModeState("read");
  };

  return (
    <Modal
      className="annual-planner-modal individual-phase-modal"
      title={
        modeState === "read"
          ? "Training Phase"
          : modeState === "edit"
          ? "Edit Phase"
          : "Remove Phase"
      }
    >
      <div className="body">
        <form
          className="annual-planner-modal-form individual-phase-modal-form"
          encType="multipart/form-data"
        >
          {modeState === "remove" && (
            <span className="chip warning">
              You are about to remove the following training phase from your
              athlete. Please confirm.
            </span>
          )}
          <div role="wrapper" className="phases-labels">
            <label>Phase Name</label>
            <label>Color</label>
          </div>

          {modeState === "edit" ? (
            <div role="wrapper" className="phase">
              <input
                autoFocus
                type={"text"}
                name={"phaseName"}
                className="phase-template-name-input text-input"
                placeholder="Enter phase name"
                defaultValue={phaseState.phaseName}
                onChange={({ target: { value } }) =>
                  handleChange("phaseName", value)
                }
              />
              <InputColor
                onChange={({ target: { value } }) =>
                  handleChange("phaseColor", value)
                }
                value={phaseState.phaseColor}
                customClassNames={"phase-color"}
              />
            </div>
          ) : (
            <div role="wrapper" className="phase">
              <span className="phase-name">{phase.phaseName}</span>
              <InputColor
                onlyRead
                colorValueClassNames={"phase-color-text"}
                value={phase.phaseColor}
                customClassNames={"phase-color"}
              />
            </div>
          )}
        </form>
      </div>
      {modeState === "read" && (
        <footer>
          <button
            type="button"
            onClick={() => setModeState("remove")}
            role="button"
            data-action="delete"
          >
            <img src="/img/new-icons/red-trash.svg" />
            Delete
          </button>
          <button
            type="button"
            onClick={() => setModeState("edit")}
            role="button"
            data-button-type="secondary"
          >
            Edit
          </button>
        </footer>
      )}
      {modeState === "edit" && (
        <footer>
          <button
            type="button"
            onClick={() => {
              setModeState("read");
              setPhaseState({
                phaseName: phase.phaseName,
                phaseColor: phase.phaseColor,
              });
            }}
            role="button"
            data-action="cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            role="button"
            data-button-type="primary"
            onClick={handleUpdate}
            disabled={!statePhaseName || !statePhaseColor}
          >
            Save
          </button>
        </footer>
      )}
      {modeState === "remove" && (
        <footer>
          <button
            type="button"
            onClick={handleRemove}
            role="button"
            data-action="delete"
          >
            <img src="/img/new-icons/red-trash.svg" />
            Delete
          </button>
          <button
            type="button"
            role="button"
            data-action="cancel"
            data-button-type="secondary"
            onClick={() => setModeState("read")}
          >
            Cancel
          </button>
        </footer>
      )}
    </Modal>
  );
};
